import defaultSettings from '@/setting';
import i18n from '@/lang';

const title = defaultSettings.title || 'WONDERLINE';

export default function getPageTitle(key) {
  const hasKey = i18n.global.te(`feroute.${key}`);
  if (hasKey) {
    const pageName = i18n.global.t(`feroute.${key}`);
    return `${pageName} - ${title}`;
  }
  return `${title}`;
}
